// Check if Clerk is available at build time
export const CLERK_AVAILABLE = !!import.meta.env["VITE_CLERK_PUBLISHABLE_KEY"];

// Demo user ID for testing without Clerk
export const DEMO_USER_ID = "demo-user-001";

/**
 * Get auth headers for API calls.
 * In demo mode, uses a test user ID header.
 * With Clerk, should use the Bearer token from getToken().
 */
export function getDemoAuthHeaders(): Record<string, string> {
  return {
    "x-clerk-user-id": DEMO_USER_ID,
  };
}

/**
 * Get auth headers with Clerk token
 */
export async function getClerkAuthHeaders(
  getToken: () => Promise<string | null>
): Promise<Record<string, string>> {
  const token = await getToken();
  if (token) {
    return {
      Authorization: `Bearer ${token}`,
    };
  }
  // Fallback to demo headers if no token
  return getDemoAuthHeaders();
}
